import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Prompt from '../components/Prompt';
import Page from '../../lib/page';
import * as emailLink from '../../../data/emailFormURL.json';
import prompt from '../constants/PromptData';
import { experience } from '../../common/commonConstants';
import { isDeployedInGoPay } from '../../lib/globalHelper';
import { guideClicked } from '../actions/action-icf-page';
import { POPULAR_ARTICLE } from '../constants/PropTypesShapes';
import { trackLink } from '../../lib/analytics-helper';
import { icfArticleUpdateContext } from '../../contactUs/actions/action-article';
import { redirectNnaToICFUrl } from '../../lib/nnaHelper';

const userExp = Page.getUserExperience();
const isLoggedIn = Page.isLoggedIn();
const PromptContainer = function (props) {
  const getPromptMessage = (exp) => {
    const currentUri = window.location.href;
    const prompts = [];
    switch (exp) {
      case experience.BUSINESS:
        if (!isDeployedInGoPay()) {
          prompts.push({
            key: 'second',
            message: prompt.second,
            buttonText: prompt.emailButton,
            buttonLink: emailLink.visitPayPalStatus,
            fptiText: 'prompt:paypal status',
            isNewTab: true,
          });
        }
        if (!isLoggedIn) {
          prompts.push({
            key: 'smc',
            message: prompt.smc,
            buttonText: prompt.logoutButton,
            buttonLink: `${emailLink.signIn}${currentUri}`,
            fptiText: 'prompt:login',
            isNewTab: false,
          });
        }
        return prompts;
      case experience.TECHNICAL:
        if (!Page.isLoggedIn()) {
          prompts.push({
            key: 'nonSmc',
            message: prompt.nonSmc,
            buttonText: prompt.logoutButton,
            buttonLink: `${emailLink.signIn}${currentUri}`,
            fptiText: 'prompt:login',
            isNewTab: false,
          });
        }
        if (!isDeployedInGoPay()) {
          prompts.push({
            key: 'second',
            message: prompt.second,
            buttonText: prompt.emailButton,
            buttonLink: emailLink.visitPayPalStatus,
            fptiText: 'prompt:paypal status',
            isNewTab: true,
          });
        }
        return prompts;

      case experience.PERSONAL:
      default:
        if (!isLoggedIn) {
          prompts.push({
            key: 'smc',
            message: prompt.smc,
            buttonText: prompt.logoutButton,
            buttonLink: `${emailLink.signIn}${currentUri}`,
            fptiText: 'prompt:login',
            isNewTab: false,
          });
        }
        if (!isDeployedInGoPay() && isLoggedIn) {
          prompts.push({
            key: 'nnaSubTitle',
            message: prompt.nnaSubTitle,
            buttonText: prompt.getStarted,
          });
        }
        return prompts;
    }
  };

  const nnaWidgetButtonClickHandler = () => {
    const { articles } = props;

    // FPTI
    trackLink({ id: 'nnaHomePage', link: 'smarthelp-home-nna-widget|button-on-click' });

    // dispatch this function to set breadcrumb
    props.guideClicked(true);

    // Update context API
    icfArticleUpdateContext(null, articles, true);

    // Redirect to ICF page
    return redirectNnaToICFUrl();
  };

  const renderPrompts = (prompts) => {
    let promptBox = null;
    if (prompts && prompts.length >= 0) {
      promptBox = prompts.map((promptItem) => {
        const isNNAWidget = promptItem.key === 'nnaSubTitle';
        if (isNNAWidget) {
          return (
            <Prompt
              key={promptItem.key}
              id={promptItem.key}
              message={promptItem.message}
              buttonText={promptItem.buttonText}
              isNNAWidget={isNNAWidget}
              guideClicked={nnaWidgetButtonClickHandler}
            />
          );
        }

        return (
          <Prompt
            key={promptItem.key}
            id={promptItem.key}
            message={promptItem.message}
            buttonText={promptItem.buttonText}
            buttonLink={promptItem.buttonLink}
            fptiText={promptItem.fptiText}
            isNewTab={promptItem.isNewTab}
          />
        );
      });
    }
    return promptBox;
  };

  return <div className="prompt-container">{renderPrompts(getPromptMessage(userExp))}</div>;
};

function mapStateToProps(state) {
  return {
    articles: state.popular.articles,
  };
}

// Dispatch the Action as Props.
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ guideClicked }, dispatch);
}

PromptContainer.propTypes = {
  articles: PropTypes.arrayOf(PropTypes.shape(POPULAR_ARTICLE)),
  // Method Prop Types.
  guideClicked: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(PromptContainer);
